const searchTopBar = document.querySelector('[data-name="search-bar-header"]');

window.addEventListener('scroll', () => {
  const scrollTop = window.pageYOffset;
    if (scrollTop > 60) {
        searchTopBar.classList.add('search-bar-header-scrolled');
    } else {
        searchTopBar.classList.remove('search-bar-header-scrolled');
    }
})